<template>
    <b-modal id="create_event_modal" @ok="createEvent">
        <template slot="modal-title">Create a new event</template>
        <form ref="create_event_form">
            <b-form-group
                    label="Name"
                    label-for="name">
                <b-form-input
                        id="name"
                        :state="validateName"
                        v-model="new_event.name"
                        autofocus
                        required/>
                <b-form-invalid-feedback :state="validateName">
                    Name is invalid, it needs at least {{minEventLength}} characters.
                </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
                    label="Project"
                    label-for="project">
                <b-form-select
                        id="project"
                        :state="validateProject"
                        v-model="new_event.project_id"
                        :options="project_options"/>
                <b-form-invalid-feedback :state="validateProject">
                    Select a project.
                </b-form-invalid-feedback>
            </b-form-group>
        </form>
    </b-modal>
</template>

<script>
    import EventRepository from "../../repositories/event.repository";

    export default {
        props: {
            new_event: {
                type: Object,
                default: EventRepository.blankEvent
            },
            minEventLength: {
                type: String,
                default: process.env.VUE_APP_VALIDATION_EVENT_MIN_EVENT_ID_LENGTH
            },
            project_options: {
                type: Array,
                default: () => []
            },
        },
        data() {
            return EventRepository.blankEvent();
        },
        methods: {
            checkFields() {
                if (EventRepository.validate.name(this.new_event.name) === false) return false;
                return true;
            },
            createEvent(modal) {
                if (this.$refs.create_event_form.checkValidity() && this.checkFields()) {
                    this.$emit('change-create-loading');
                    EventRepository.post(this.new_event).then(res => {
                        if (res.status === 201) { // Status 201 means created
                            // Emit the event-created event.
                            this.$emit('change-create-loading');
                            this.$emit('event-created', res.data.event);
                            // Restore the create  event form.
                            this.new_event = EventRepository.blankEvent();
                            // Notify the user.
                            this.$bvToast.toast(`Event ${res.data.event.name} successfully created.`, {
                                title: `Event created.`,
                                variant: 'success',
                                solid: true
                            });
                        } else {
                            this.$bvToast.toast('Looks like something went wrong while creating a new event.', {
                                title: `Event creation error.`,
                                variant: 'danger',
                                solid: true
                            });
                        }
                    }).catch(error => {
                        this.$emit('change-create-loading');
                        if (error.response.status === 422) {
                            console.error("Errorcode: " + error.response.status + " Type: " + error.response.statusText + " \n details:" + error.response.data['hydra:description']);
                            this.$bvToast.toast('Looks like something went wrong while validating the new event. Check the value\'s of all the fields', {
                                title: `Event creation error.`,
                                variant: 'danger',
                                solid: true
                            });
                        } else if (error.response.status === 409) {
                            console.error("Errorcode: " + error.response.status + " Type: " + error.response.statusText + ". Check if the event doesn't exists already.");
                            this.$bvToast.toast('Looks like something went wrong while creating the new event. Check if the event doesn\'t exists already.', {
                                title: `Event creation error.`,
                                variant: 'danger',
                                solid: true
                            });
                        } else {
                            console.error("Errorcode: " + error.response.status + " Type: " + error.response.statusText);
                            this.$bvToast.toast('Looks like something went wrong on the server while creating a new event.', {
                                title: `Event creation error.`,
                                variant: 'danger',
                                solid: true
                            });
                        }
                    });
                } else {
                    modal.preventDefault();
                }
            }
        },
        computed: {
            validateName() {
                return EventRepository.validate.name(this.new_event.name);
            }
        }
    }
</script>
